import { render } from "./LoadingButton.vue?vue&type=template&id=e898569a"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import "./LoadingButton.vue?vue&type=style&index=0&id=e898569a&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__